import axios from "axios";
import { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

// formik components
import { Formik, Form } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// NewUser layout schemas for form and form feilds
import validations from "./schemas/Validations";
import form from "./schemas/Form";
import UserInfo from "./components/UserInfo";

import { TableDataContext } from "context/TableDataContext";

import { URL_API } from "config";
import { CrudUserContext } from "context/CrudUserContext";

function getSteps() {
  return ["Dados"];
}

function getStepContent(stepIndex, formData) {
  switch (stepIndex) {
    case 0:
      return <UserInfo formData={formData} />;
    default:
      return null;
  }
}

export default function UpdateUser() {
  const { inputCompany } = useContext(CrudUserContext);
  const route = useLocation().pathname.split("/").slice(1);
  const uuid = route[route.length - 1];
  const { pageRowAndIndex } = useContext(TableDataContext);
  const { row } = pageRowAndIndex;
  const {
    formField: {
      // datas
      name,
      email,
    },
  } = form;
  const values = {
    // datas
    [name.name]: row.original?.name,
    [email.name]: row.original?.email,
    company: row.original?.company_name ?? "",
    companyUuid: row.original?.company_id ?? "",
  };

  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const { formId, formField } = form;
  const currentValidation = validations[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const navigate = useNavigate();
  let tag = localStorage.getItem("Tag");

  const handleBack = () => setActiveStep(activeStep - 1);

  const submitForm = async (values, actions) => {
    const user = {
      name: values?.name,
      email: values?.email,
      company_name: inputCompany?.name,
      company_id: inputCompany?.uuid,
    };

    await axios
      .put(URL_API + `/user/${uuid}`, user, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then(() => {
        navigate("/admin/usuarios");
        toast.success("Dados atualizados com sucesso");
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      })
      .finally(() => {
        actions.setSubmitting(false);
        actions.resetForm();

        setActiveStep(0);
      });
  };

  const handleSubmit = (values, actions) => {
    if (isLastStep) {
      submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mb={5}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ height: "100%", mt: 8 }}
          >
            <Grid item xs={12} lg={8}>
              <Formik
                initialValues={values}
                validationSchema={currentValidation}
                onSubmit={handleSubmit}
              >
                {({ values, errors, touched, isSubmitting }) => (
                  <Form id={formId} autoComplete="off">
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={3}>
                        <MDBox>
                          {getStepContent(activeStep, {
                            values,
                            touched,
                            formField,
                            errors,
                          })}
                          <MDBox
                            mt={2}
                            width="100%"
                            display="flex"
                            justifyContent="space-between"
                          >
                            {activeStep === 0 ? (
                              <MDBox />
                            ) : (
                              <MDButton
                                variant="gradient"
                                color="light"
                                onClick={handleBack}
                              >
                                voltar
                              </MDButton>
                            )}
                            <MDButton
                              disabled={isSubmitting}
                              type="submit"
                              variant="gradient"
                              color="dark"
                            >
                              {isLastStep ? "salvar" : "próximo"}
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />
    </>
  );
}
